import React from 'react';
import InstitucionalFrame from './InstitucionalFrame';

const InstitucionalClube: React.FC = () => (
  <InstitucionalFrame page="clube.html" title="Clube InPlay" />
);

export default InstitucionalClube;
